/* ============================================================
   BERUNDA — Product page behaviour (shared by all three PDPs)
   The page root carries data-product="<process>" — the same
   normalized key the collection cards and the cart use.
   Deep links: ?format=whole|drip|ground pre-selects a format
   (ads, filter links); the URL stays in sync as the visitor
   toggles. Brew rules:
     · Whole  — no brew step
     · Drip   — no brew step, pair offer
     · Ground — brew method REQUIRED (unless fixedBrew — Dhrona)

   Prices, labels, images and variant IDs come from #berunda-catalog
   (built from Shopify in snippets/berunda-product-modal.liquid and
   rendered on every page) — never from a second copy here, so the
   page, the cart drawer and checkout can never disagree on money.
   ============================================================ */
(function () {
  "use strict";

  var CATALOG = {};
  try {
    var src = document.getElementById("berunda-catalog");
    if (src) CATALOG = JSON.parse(src.textContent);
  } catch (e) {}

  var root = document.querySelector(".pp");
  if (!root) return;
  var handle = root.getAttribute("data-product");
  var p = CATALOG[handle];
  if (!p) return;

  function id(s) { return document.getElementById(s); }
  var elImg = id("pp-img");
  var elDesc = id("pp-desc");
  var elSpecs = id("pp-specs");
  var elPrice = id("pp-price");
  var elDeal = id("pp-deal");
  var elQty = id("pp-qty");
  var elDripBags = id("pp-drip-bags");
  var elDripBagSelect = id("pp-drip-bag-select");
  var addBtn = id("pp-add");
  var elHint = id("pp-hint");
  var brewstep = id("pp-brewstep");
  var brewrow = id("pp-brewrow");
  var brewfixed = id("pp-brewfixed");
  var brewReq = id("pp-brew-req");
  var brewLabel = id("pp-brew-label");
  var guideBtn = id("pp-brewguide");
  var toast = id("col-toast");
  var formatBtns = [].slice.call(document.querySelectorAll(".col-modal-format"));
  var qtyBtns = [].slice.call(document.querySelectorAll(".col-qty-btn"));
  var brewtiles = [].slice.call(document.querySelectorAll("#pp-brewrow .col-brewtile"));

  var guide = window.BerundaBrewGuide || null;
  var BREWS = guide ? guide.BREWS : {};

  var qty = 1;
  var selectedDripVariantId = null;
  var selectedBrew = null;
  var addTimer = null;
  var toastTimer = null;

  /* ---- format: URL first, else the coffee's default ----
     The deep link is Shopify's own ?variant=<id>, NOT the ?format=<name> the
     static kit used: `format` is a reserved Shopify query parameter and
     /products/<handle>?format=whole answers 404 on the live store. Since
     product.js writes this parameter into the address bar on first paint,
     using `format` would leave every visitor holding a URL that 404s the
     moment they refresh or share it. ?variant= is native — Shopify selects
     the variant server-side too, so the page is right even before JS runs. */
  function formatOfVariant(id) {
    var found = null;
    Object.keys(p.formats).forEach(function (key) {
      var format = p.formats[key];
      var variants = format.variants || [];
      if (String(format.variantId) === String(id) || variants.some(function (variant) {
        return String(variant.variantId) === String(id);
      })) found = key;
    });
    return found;
  }
  var urlFormat = null;
  try {
    urlFormat = formatOfVariant(new URLSearchParams(window.location.search).get("variant"));
  } catch (e) {}
  /* Failing an explicit variant, open on the format belonging to the product
     whose URL this is (the drip box's own page shows Drip), then the coffee's
     catalog default. */
  var pageFormat = root.getAttribute("data-open-format");
  var currentFormat = p.formats[urlFormat] ? urlFormat
    : (p.formats[pageFormat] ? pageFormat : p.defaultFormat);
  if (currentFormat === "drip" && urlFormat === "drip") {
    selectedDripVariantId = new URLSearchParams(window.location.search).get("variant");
  }

  /* Edit the existing query string rather than rebuilding it: writing it from
     scratch threw away every other parameter, so a visitor arriving on a
     campaign link lost its utm_* tags before anything read them. */
  function syncUrl() {
    try {
      var f = fmt();
      if (!f || !f.variantId) return;
      var params = new URLSearchParams(window.location.search);
      params.set("variant", f.variantId);
      window.history.replaceState(null, "", window.location.pathname + "?" + params.toString());
    } catch (e) {}
  }

  function fmt() {
    var format = p.formats[currentFormat];
    if (currentFormat !== "drip" || !format || !format.variants || !format.variants.length) return format;
    var variant = format.variants.filter(function (item) {
      return String(item.variantId) === String(selectedDripVariantId);
    })[0] || format.variants[0];
    return Object.assign({}, format, variant, { label: format.label + " · " + variant.label });
  }
  function isGround() { return currentFormat === "ground"; }
  function fixedBrewName() { return p.fixedBrew || null; }
  function money(cents) { return "₹" + Math.round(cents / 100).toLocaleString("en-IN"); }

  /* ---- price + pair offer ---- */
  function dealFor(f) {
    return (currentFormat === "drip" && f && f.deal) ? f.deal : null;
  }
  function priceParts(f) {
    var base = f.priceCents * qty;
    var deal = dealFor(f);
    var off = (deal && qty >= deal.minQty) ? deal.amountCents : 0;
    return { base: base, off: off, net: base - off };
  }
  function renderPrice() {
    var f = fmt();
    if (!f || !elPrice) return;
    elPrice.textContent = money(priceParts(f).net);
    renderDeal(f);
  }
  function renderDeal(f) {
    if (!elDeal) return;
    var deal = dealFor(f);
    if (!deal) { elDeal.hidden = true; elDeal.textContent = ""; return; }
    var pairWas = f.priceCents * deal.minQty;
    var pairNow = pairWas - deal.amountCents;
    elDeal.hidden = false;
    elDeal.setAttribute("aria-label", "Take " + deal.minQty + " drip boxes for " + money(pairNow) + " instead of " + money(pairWas) + " — save " + money(deal.amountCents) + ", add both to cart");
    elDeal.innerHTML =
      '<span class="pp-deal-head">Pair Offer — Save ' + money(deal.amountCents) + '</span>' +
      '<span class="pp-deal-sub"><strong>' + money(pairNow) + '</strong><s>' + money(pairWas) + '</s></span>' +
      '<span class="pp-deal-cta"><span>Add ' + deal.minQty + ' Boxes</span><span class="pp-deal-arrow" aria-hidden="true">→</span></span>';
  }

  function setQty(n) {
    qty = Math.max(1, Math.min(99, n));
    if (elQty) elQty.textContent = String(qty);
    qtyBtns.forEach(function (b) {
      if (parseInt(b.getAttribute("data-qty"), 10) < 0) b.disabled = qty <= 1;
    });
    renderPrice();
  }

  function renderSpecs(f) {
    if (!elSpecs) return;
    elSpecs.innerHTML = "";
    (f.specs || []).forEach(function (row) {
      var div = document.createElement("div");
      div.className = "pp-spec";
      var dt = document.createElement("dt"); dt.textContent = row[0];
      var dd = document.createElement("dd"); dd.textContent = row[1];
      div.appendChild(dt); div.appendChild(dd);
      elSpecs.appendChild(div);
    });
  }

  function renderDripBagSelector() {
    var drip = p.formats.drip;
    var variants = drip && drip.variants ? drip.variants : [];
    var visible = currentFormat === "drip" && variants.length > 0;
    if (elDripBags) elDripBags.hidden = !visible;
    if (!visible || !elDripBagSelect) return;

    elDripBagSelect.innerHTML = "";
    variants.forEach(function (variant) {
      var option = document.createElement("option");
      option.value = variant.variantId;
      option.textContent = variant.label;
      elDripBagSelect.appendChild(option);
    });
    elDripBagSelect.value = String(fmt().variantId);
  }

  /* ---- the Add gate + its plain-words hint ---- */
  function addLocked() { return isGround() && !selectedBrew && !fixedBrewName(); }
  function paintGate() {
    var locked = addLocked();
    addBtn.classList.toggle("is-locked", locked);
    if (locked) addBtn.setAttribute("aria-disabled", "true");
    else addBtn.removeAttribute("aria-disabled");
    if (elHint) {
      elHint.hidden = !locked;
      if (!locked) elHint.classList.remove("is-urgent");
    }
  }

  /* ---- brew tiles ---- */
  function fillTiles() {
    if (!guide) return;
    brewtiles.forEach(function (tile) {
      var type = tile.getAttribute("data-brew");
      var anim = tile.querySelector(".col-brewtile-anim");
      if (anim) anim.innerHTML = guide.machineSVG(type);
    });
  }
  function updateTiles() {
    brewtiles.forEach(function (tile) {
      var sel = tile.getAttribute("data-brew") === selectedBrew;
      tile.classList.toggle("is-selected", sel);
      var sq = tile.querySelector(".col-brewtile-sq");
      if (sq) sq.setAttribute("aria-pressed", sel ? "true" : "false");
    });
    if (guide) guide.setSelected(selectedBrew);
  }
  function lockBrew(method) {
    /* Airavata alone can offer Espresso and South Indian Filter. These are
       product choices, not Brew Guide recipes, hence they are intentionally
       absent from guide.BREWS. */
    if (!BREWS[method] && method !== "espresso" && method !== "sifilter") return;
    selectedBrew = method;
    updateTiles();
    paintGate();
  }
  function renderFixedTile(name) {
    if (!brewfixed || !guide) return;
    if (brewfixed.getAttribute("data-brew-name") !== name) {
      brewfixed.setAttribute("data-brew-name", name);
      brewfixed.innerHTML =
        '<div class="col-brewtile is-selected">' +
          '<div class="col-brewtile-sqwrap">' +
            '<span class="col-brewtile-sq" aria-hidden="true"><span class="col-brewtile-anim">' + guide.machineSVG("sifilter") + '</span></span>' +
          '</div>' +
          '<span class="col-brewtile-name">' + name + '</span>' +
        '</div>';
    }
  }
  function applyBrewGate() {
    var fixed = isGround() ? fixedBrewName() : null;
    if (brewrow) brewrow.hidden = !!fixed;
    if (brewfixed) brewfixed.hidden = !fixed;
    if (guideBtn) guideBtn.hidden = !!fixed;
    if (brewReq) brewReq.hidden = !!fixed;
    if (brewLabel) brewLabel.textContent = fixed ? "Brew Method" : "Choose Your Brew Method";
    if (fixed) {
      if (brewstep) brewstep.hidden = false;
      renderFixedTile(fixed);
      selectedBrew = null;
      updateTiles();
    } else if (isGround()) {
      if (brewstep) brewstep.hidden = false;
      selectedBrew = null;
      if (brewrow) brewrow.classList.remove("is-nudge");
      updateTiles();
    } else {
      if (brewstep) brewstep.hidden = true;
      selectedBrew = null;
      updateTiles();
    }
    paintGate();
  }

  /* ---- render everything for the current format ---- */
  function render() {
    var f = fmt();
    if (!f) return;
    if (elDesc) elDesc.textContent = f.desc || "";
    renderSpecs(f);
    renderPrice();
    renderDripBagSelector();

    formatBtns.forEach(function (b) {
      var key = b.getAttribute("data-format");
      var has = !!p.formats[key];
      b.hidden = !has;
      if (has) {
        var parts = (p.formats[key].label || "").split(" · ");
        b.innerHTML = "";
        var nameEl = document.createElement("span");
        nameEl.className = "col-modal-format-name";
        nameEl.textContent = parts[0] || "";
        b.appendChild(nameEl);
        if (parts[1]) {
          var sizeEl = document.createElement("span");
          sizeEl.className = "col-modal-format-size";
          sizeEl.textContent = parts[1];
          b.appendChild(sizeEl);
        }
      }
      b.setAttribute("aria-checked", key === currentFormat ? "true" : "false");
    });

    if (elImg && f.img && elImg.getAttribute("src") !== f.img) {
      elImg.style.opacity = "0";
      var next = f.img;
      var swap = function () {
        elImg.src = next;
        elImg.alt = p.name + " — " + (f.label || "");
        elImg.style.opacity = "1";
      };
      setTimeout(swap, 160);
    }

    resetAddBtn();
    applyBrewGate();
  }

  function resetAddBtn() {
    if (addTimer) { clearTimeout(addTimer); addTimer = null; }
    addBtn.classList.remove("is-added");
    addBtn.querySelector("span").textContent = "Add to Cart";
  }

  function showToast() {
    if (!toast) return;
    toast.classList.add("is-shown");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("is-shown"); }, 2400);
  }

  /* ---- add to cart ---- */
  function performAdd() {
    var f = fmt();
    if (!f || !f.variantId) return;
    if (addLocked()) {
      if (brewrow) {
        brewrow.classList.add("is-nudge");
        setTimeout(function () { brewrow.classList.remove("is-nudge"); }, 600);
      }
      if (elHint) {
        elHint.classList.remove("is-urgent");
        void elHint.offsetWidth;
        elHint.classList.add("is-urgent");
      }
      return;
    }
    /* A fixed-brew cup (Dhrona) shows its method locked rather than chosen, so
       selectedBrew stays null — take the fixed name instead, or the line reaches
       the cart with no brew method while the page displayed one. */
    var note = "";
    if (isGround()) {
      note = fixedBrewName() ||
        ((selectedBrew && BREWS[selectedBrew]) ? BREWS[selectedBrew].name :
          (selectedBrew === "espresso" ? "Espresso" :
            (selectedBrew === "sifilter" ? "South Indian Filter" : "")));
    }
    if (window.BerundaCart) {
      window.BerundaCart.add(f.variantId, qty, {
        name: p.name, format: f.label, price: f.price, img: f.img,
        properties: note ? { "Brew Method": note } : null, note: note
      });
    }
    addBtn.classList.add("is-added");
    addBtn.querySelector("span").textContent = "Added ✓";
    showToast();
    if (addTimer) clearTimeout(addTimer);
    addTimer = setTimeout(resetAddBtn, 1600);
  }

  /* ---- wiring ---- */
  formatBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      var key = b.getAttribute("data-format");
      if (p.formats[key] && key !== currentFormat) {
        currentFormat = key;
        setQty(1);
        syncUrl();
        render();
      }
    });
  });

  if (elDripBagSelect) {
    elDripBagSelect.addEventListener("change", function () {
      selectedDripVariantId = elDripBagSelect.value;
      setQty(1);
      syncUrl();
      render();
    });
  }

  qtyBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      setQty(qty + parseInt(b.getAttribute("data-qty"), 10));
    });
  });

  addBtn.addEventListener("click", performAdd);

  if (elDeal) {
    elDeal.addEventListener("click", function () {
      var deal = dealFor(fmt());
      if (!deal) return;
      setQty(deal.minQty);
      performAdd();
    });
  }

  if (brewrow && guide) {
    fillTiles();
    brewtiles.forEach(function (tile) {
      var type = tile.getAttribute("data-brew");
      tile.addEventListener("click", function () { lockBrew(type); });
    });
    guide.onPick(function (type) { lockBrew(type); });
  }

  /* first paint */
  if (elImg) elImg.style.transition = "opacity 0.28s var(--ease-standard, ease)";
  setQty(1);
  syncUrl();
  render();
})();

/* Sticky buy bar (≤680px). Once the real buy row has scrolled off the top,
   the price and Add to Cart follow the visitor down the page — most buyers
   are on a phone and the saga leaf below is long. The bar never adds
   anything itself: it clicks the real button so product.js keeps sole
   ownership of the brew gate, and steers to the brew step when gated. */
(function () {
  "use strict";
  var mq = window.matchMedia("(max-width: 680px)");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var pp = document.querySelector(".pp");
  var add = document.getElementById("pp-add");
  var buyRow = pp && pp.querySelector(".col-modal-buy");
  if (!pp || !add || !buyRow) return;

  var bar = document.createElement("div");
  bar.className = "m-buybar";
  bar.innerHTML =
    '<div class="m-buybar-info">' +
      '<span class="m-buybar-name"></span>' +
      '<span class="m-buybar-price"></span>' +
    '</div>' +
    '<button class="m-buybar-add" type="button">Add to Cart</button>';
  document.body.appendChild(bar);

  var nameEl = bar.querySelector(".m-buybar-name");
  var priceEl = bar.querySelector(".m-buybar-price");
  var srcName = document.querySelector(".pp-name");
  var srcPrice = document.getElementById("pp-price");
  function sync() {
    nameEl.textContent = srcName ? srcName.textContent : "";
    priceEl.textContent = srcPrice ? srcPrice.textContent : "";
  }
  sync();
  if (srcPrice && "MutationObserver" in window) {
    new MutationObserver(sync).observe(srcPrice, { childList: true, characterData: true, subtree: true });
  }

  function update() {
    /* show once the buy row's bottom has scrolled above the viewport top */
    var footer = document.querySelector(".bf-footer");
    var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
    var show = mq.matches && buyRow.getBoundingClientRect().bottom < 8 && beforeFooter;
    bar.classList.toggle("is-show", show);
    document.documentElement.classList.toggle("m-has-buybar", show);
  }
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();

  bar.querySelector(".m-buybar-add").addEventListener("click", function () {
    add.click(); /* product.js owns the brew gate */
    setTimeout(function () {
      var hint = document.getElementById("pp-hint");
      var brew = document.getElementById("pp-brewstep");
      if (hint && !hint.hidden && brew && !brew.hidden) {
        window.scrollTo({
          top: brew.getBoundingClientRect().top + window.scrollY - 96,
          behavior: reduced ? "auto" : "smooth"
        });
        brew.classList.remove("m-pulse");
        void brew.offsetWidth;
        brew.classList.add("m-pulse");
      }
    }, 80);
  });
})();

/* Back link — history-aware. Arriving from another page of the site (not the
   collection itself) turns it into a plain "Back" that pops history. */
(function () {
  "use strict";
  var link = document.querySelector(".pp-back");
  if (!link) return;
  var ref = document.referrer;
  if (!ref || !history.length) return;
  var from;
  try { from = new URL(ref); } catch (e) { return; }
  if (from.origin !== location.origin) return;
  /* the collection's own path comes from the link's href — the handle is the
     owners' to rename, so it is never hardcoded here. */
  var collectionPath = link.getAttribute("href");
  if (from.pathname === collectionPath || from.href === location.href) return;
  var label = link.querySelector("span:last-child");
  if (label) label.textContent = "Back";
  link.setAttribute("href", ref);
  link.addEventListener("click", function (e) {
    e.preventDefault();
    history.back();
  });
})();

/* The reveal — on first load the page leans down a little, holds, and rises
   back: just enough motion to prove the crimson block is not the whole page.
   Ported from the design kit's inline product-page script (identical across
   all three static pages, per the export's HANDOFF.md) — it was dropped when
   product.js was rewritten to read the Shopify catalog instead of the kit's
   hardcoded one. Runs on every load, not once per session — the kit's own
   ONCE_PER_SESSION flag ships as false. Abandoned the moment the visitor
   scrolls, taps or presses a key themselves. */
(function () {
  "use strict";
  if (!document.querySelector(".pp")) return;
  var ONCE_PER_SESSION = false; /* flip to true to show the dip only on the first product page of a visit */
  var KEY = "berunda:pp-reveal-4";
  var root = document.documentElement;
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  try { if (ONCE_PER_SESSION && sessionStorage.getItem(KEY)) return; } catch (e) {}
  /* Only once the dip is actually going to run — it starts from the top, so the
     browser must not restore a previous scroll position underneath it. Setting
     this before the returns above stripped scroll restoration from every visitor
     who never sees the reveal. */
  try { if ("scrollRestoration" in history) history.scrollRestoration = "manual"; } catch (e) {}
  var cancelled = false;
  ["wheel", "touchstart", "keydown"].forEach(function (n) {
    addEventListener(n, function (e) { if (e.isTrusted) cancelled = true; }, { passive: true });
  });
  function inOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function settle(t) { return 1 - Math.pow(1 - t, 4); }
  function glide(from, to, dur, curve, done) {
    var t0 = performance.now();
    root.style.scrollBehavior = "auto";
    (function step(now) {
      if (cancelled) { root.style.scrollBehavior = ""; return; }
      var p = Math.min(1, (now - t0) / dur);
      scrollTo(0, from + (to - from) * curve(p));
      if (p < 1) requestAnimationFrame(step);
      else { root.style.scrollBehavior = ""; if (done) done(); }
    })(t0);
  }
  function begin() {
    setTimeout(function () {
      if (cancelled) return;
      try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
      if (scrollY > 4) { root.style.scrollBehavior = "auto"; scrollTo(0, 0); root.style.scrollBehavior = ""; }
      var dip = Math.min(150, Math.max(0, document.documentElement.scrollHeight - innerHeight));
      glide(0, dip, 700, inOut, function () {
        setTimeout(function () { glide(dip, 0, 800, settle); }, 300);
      });
    }, 1000);
  }
  begin(); /* runs from a deferred script, same as the kit's end-of-body inline one */
})();
